<template>
  <fragment v-if="member">
    <common-header v-bind:menus="menus" v-bind:buttons="buttons">
      <h2 class="page-tit">
        <small class="text-white">{{member ? member.mberId : ""}}</small>
        {{member ? member.mberName : ""}}
        <span
          class="auth_label label"
          :style="{'background-color': auth.color}"
          v-for="(auth, idx) in member.authAllotList"
          :key="`auth-label-${idx}`"
        >{{auth.authName}}</span>
      </h2>
    </common-header>

    <section ref="container" class="container">
      <nav class="side-nav">
        <a class="btn full-width round m-b-10" @click="$router.go(-1)">뒤로가기</a>
        <ul class="side-nav-menu clearfix">
          <li>
            <router-link
              :to="'/users/detail/'+$route.params.id"
              :class="{on:$route.fullPath.indexOf('apply')==-1&&$route.fullPath.indexOf('progress')==-1&&$route.fullPath.indexOf('qna')==-1}&&$route.fullPath.indexOf('articles')==-1&&$route.fullPath.indexOf('comments')==-1"
            >회원정보</router-link>
          </li>
          <li>
            <router-link
              :to="'/users/detail/'+$route.params.id+'/apply'"
              :class="{on:$route.fullPath.indexOf('apply')!=-1}"
            >수강 신청관리</router-link>
          </li>
          <!-- <li class="on">
            <router-link
              :to="'/users/detail/'+$route.params.id+'/progress'"
              :class="{on:$route.fullPath.indexOf('progress')!=-1}"
            >수강현황관리</router-link>
          </li> -->
          <!-- <li>
            <router-link
              :to="'/users/detail/'+$route.params.id+'/qna'"
              :class="{on:$route.fullPath.indexOf('qna')!=-1}"
            >1:1 문의</router-link>
          </li>
          <li>
            <router-link
              :to="'/users/detail/'+$route.params.id+'/articles'"
              :class="{on:$route.fullPath.indexOf('articles')!=-1}"
            >작성한 게시물</router-link>
          </li>
          <li>
            <router-link
              :to="'/users/detail/'+$route.params.id+'/comments'"
              :class="{on:$route.fullPath.indexOf('comments')!=-1}"
            >작성한 댓글</router-link>
          </li> -->
        </ul>
      </nav>

      <router-view
        :member="member"
        :jobQuestions="jobQuestions"
        :authList="authList"
        @onDone="onDone"
        @onConfirm="onConfirm"
        @onRefresh="onRefresh"
        @onSms="openSmsModal"
        @onEmail="openEmailModal"
        @openApplyDetailModal="openApplyDetailModal"
        @openProgressStatus="openProgressStatus"
      ></router-view>
    </section>

    <common-footer></common-footer>

    <modal-apply-detail
      :config="modals.ModalApplyDetail"
      :key="hash(modals.ModalApplyDetail)"
      @close="modals.ModalApplyDetail.show=false"
    ></modal-apply-detail>
    <modal-class-status
      :config="modals.ModalClassStatus"
      :key="hash(modals.ModalClassStatus)"
      @close="modals.ModalClassStatus.show=false;"
    ></modal-class-status>

    <modal-email
      :config="modals.ModalEmail"
      @close="modals.ModalEmail.show=false;"
      :key="hash(modals.ModalEmail)"
      @onDone="onDone"
      @onConfirm="onConfirm"
    ></modal-email>
    <modal-sms
      :config="modals.ModalSms"
      @close="modals.ModalSms.show=false;"
      :key="hash(modals.ModalSms)"
      @onDone="onDone"
      @onConfirm="onConfirm"
    ></modal-sms>
    <modal-confirm
      :config="modals.ModalConfirm"
      @yes="modals.ModalConfirm.show=false"
      @no="modals.ModalConfirm.show=false"
      :key="hash(modals.ModalConfirm)"
    ></modal-confirm>
    <modal-alert
      :config="modals.ModalAlert"
      @close="modals.ModalAlert.show=false;"
      :key="hash(modals.ModalAlert)"
    ></modal-alert>
  </fragment>
</template>

<script>
import fnAdjustHeight from "../mixins/fnAdjustHeight.js";
import CommonHeader from "../components/CommonHeader.vue";
import CommonFooter from "../components/CommonFooter.vue";
import axios from "axios";
import server from "../statics/server";

import ModalEmail from "../modals/ModalEmail.vue";
import ModalSms from "../modals/ModalSms.vue";
import ModalAlert from "../modals/ModalAlert.vue";
import ModalConfirm from "../modals/ModalConfirm.vue";
import ModalApplyDetail from "../modals/ModalApplyDetail.vue";
import ModalClassStatus from "../modals/ModalClassStatus.vue";

export default {
  // 컴포넌트명
  name: "ViewUserDetail",
  mixins: [fnAdjustHeight],
  mounted: async function() {
    await this.getMemberData();
    await this.getJobQuestions();
    await this.getAuthAlloList();
  },
  // 이 컴포넌트에서 내부적으로 사용할 데이터 (=state)
  data: function() {
    return {
      menus: [], // 서브메뉴
      buttons: [], // 헤더버튼
      member: null,
      jobQuestions: [],
      authList: [],
      modals: {
        ModalEmail: ModalEmail.default(),
        ModalSms: ModalSms.default(),
        ModalAlert: ModalAlert.default(),
        ModalConfirm: ModalConfirm.default(),
        ModalApplyDetail: ModalApplyDetail.default(),
        ModalClassStatus: ModalClassStatus.default()
      }
    };
  },

  // 이 컴포넌트에서 사용할 자식컴포넌트 목록
  components: {
    CommonHeader,
    CommonFooter,
    ModalEmail,
    ModalSms,
    ModalConfirm,
    ModalAlert,
    ModalApplyDetail,
    ModalClassStatus
  },

  // 이 컴포넌트에서 구현되어야 할 기능
  methods: {
    openEmailModal: function() {
      this.modals.ModalEmail.sendList = [
        {
          name: this.member.mberName,
          email: this.member.email
        }
      ];
      this.modals.ModalEmail.show = true;
    },
    openSmsModal: function() {
      this.modals.ModalSms.sendList = [
        {
          name: this.member.mberName,
          mobileNum: this.member.mobileNum
        }
      ];
      this.modals.ModalSms.show = true;
    },
    getJobQuestions: async function() {
      const { workCode } = this.member;

      if (!workCode) return;

      try {
        const { data } = await axios.post(
          `${server.addr()}${server.api.WORK_INFO}`,
          { workCode }
        );
        this.jobQuestions = data.list;

        // eslint-disable-next-line
        // console.log("이게 뭐지?", data.list);
      } catch (e) {
        // TODO : error exception
      }
    },
    getMemberData: async function() {
      const { id } = this.$route.params;

      try {
        const { data } = await axios.post(
          `${server.addr()}${server.api.MBER}/${id}`
        );
        if (!data.return.authAllotList) data.return["authAllotList"] = [];
        if (!data.return.instInfoList || data.return.instInfoList.length <= 0)
          data.return["instInfoList"] = [{}];
        this.member = data.return;
      } catch (e) {
        // TODO: error exception
      }
    },
    getAuthAlloList: async function() {
      try {
        const { data } = await axios.post(
          `${server.addr()}${server.api.AUTH}`,
          {}
        );
        this.authList = data.list;
      } catch (e) {
        // TODO: error exception
      }
    },
    // authId로 auth 받아오기
    getAuth: function(authId) {
      return this.authList.find(e => e.authId === authId);
    },
    onRefresh: async function() {
      await this.getMemberData();
      await this.getJobQuestions();
    },
    // 서브클레스에서 confirm띄울때
    onConfirm: function(options) {
      this.modals.ModalConfirm.msg = options.message;
      this.modals.ModalConfirm.btnYes.name = "확인";
      this.modals.ModalConfirm.btnYes.fn = () => {
        options.yesCb();
        this.modals.ModalConfirm.show = false;
      };
      this.modals.ModalConfirm.btnNo.name = "취소";
      this.modals.ModalConfirm.btnNo.fn = () => {
        if (typeof options.noCb === "function") options.noCb();
        this.modals.ModalConfirm.show = false;
      };
      this.modals.ModalConfirm.show = true;
    },
    // 서브클레스에서 alert 띄울때 사용한는 함수
    onDone: function(message) {
      this.modals.ModalAlert.msg = message;
      this.modals.ModalAlert.show = true;
    },
    openApplyDetailModal: function(appl) {
      this.modals.ModalApplyDetail.appl_info = appl;
      this.modals.ModalApplyDetail.show = true;
    },
    openProgressStatus: function(appl) {
      this.modals.ModalClassStatus.appl = appl;
      this.modals.ModalClassStatus.show = true;
    }
  }
};
</script>



<style scoped>
.auth_label.label {
  background-color: #999;
}
.msg-i {
  fill: #999;
  fill-rule: evenodd;
}
.btn-group .btn:hover .msg-i {
  fill: #fff;
  fill-rule: evenodd;
}
.sms-i {
  fill: #999;
  fill-rule: evenodd;
}
.btn-group .btn:hover .sms-i {
  fill: #fff;
  fill-rule: evenodd;
}
.re {
  fill: #999;
  fill-rule: evenodd;
}
.btn-group .btn:hover .re {
  fill: #fff;
  fill-rule: evenodd;
}
</style>